import {
  ORDER_METHODS,
  SMART_PRICING_MODIFIER_TYPE,
  SMART_PRICING_RESOURCE_TYPE,
} from '../../../../../services/exports/Constants';

export default {
  title: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Regra de preço inteligente global de {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Regra de preço inteligente principal de {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.menu]: 'Regra de preço inteligente de menu de {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.category]: 'Regra de preço inteligente de categoria de {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.product]: 'Regra de preço inteligente de produto de {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Regra de preço inteligente de grupo de modificadores de {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Regra de preço inteligente de modificador de {{name}}',
  },
  labels: {
    new: 'Novo',
    base_price: 'Preço base de {{name}}: {{value}}',
  },
  form: {
    resource: {
      [SMART_PRICING_RESOURCE_TYPE.menu]: 'Menu',
      [SMART_PRICING_RESOURCE_TYPE.category]: 'Categoria',
      [SMART_PRICING_RESOURCE_TYPE.product]: 'Produto',
      [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Grupo de modificadores',
      [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Modificador',
      placeholder: 'Selecionar {{resource}}',
    },
    order_methods: {
      label: 'Métodos de pedido',
      placeholder: 'Selecionar os métodos de pedido aos quais a regra se aplica',
      options: {
        [ORDER_METHODS.pickup]: 'Recolha',
        [ORDER_METHODS.delivery]: 'Entrega',
        [ORDER_METHODS.room_service]: 'Serviço de quarto/mesa',
      },
    },
    modifier_type: {
      label: 'Tipo de modificador de preço',
      placeholder: 'Selecionar tipo de modificador de preço',
      disabled_tooltip:
        'O valor absoluto não está disponível para regras de menu completo porque substituiria o preço de cada item.',
      tooltip: {
        title: 'O tipo de modificador define a forma como os preços são alterados',
        description: {
          [SMART_PRICING_MODIFIER_TYPE.absolute]:
            'Absoluto: substitui o preço do recurso pelo valor do modificador especificado',
          [SMART_PRICING_MODIFIER_TYPE.percentage]:
            'Percentagem: adiciona/subtrai a percentagem do modificador especificado ao/do preço base do recurso conforme o sinal do valor',
          [SMART_PRICING_MODIFIER_TYPE.fixed_value]:
            'Valor fixo: adiciona/subtrai o valor fixo do modificador especificado ao/do preço base conforme o sinal do valor',
        },
      },
      options: {
        [SMART_PRICING_MODIFIER_TYPE.absolute]: 'Absoluto',
        [SMART_PRICING_MODIFIER_TYPE.percentage]: 'Percentagem',
        [SMART_PRICING_MODIFIER_TYPE.fixed_value]: 'Valor fixo',
      },
    },
    modifier_value: {
      label: 'Valor do modificador de preço',
    },
    round: {
      label: 'Arredondar o preço resultante',
      tooltip:
        'Arredonda o preço resultante para cima em 10 (ex.: 14,91, 14,93, 14,99 passam a 15,00). Útil principalmente para regras de percentagem',
    },
    is_visible: {
      label: 'Mostrar ao cliente como promoção',
    },
    name: {
      label: 'Nome',
      placeholder: 'Inserir nome amigável para o cliente',
      default: '{{value}} de desconto em {{resource}}',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
    failed_to_save_changes: 'Falha ao guardar alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
